import React, { useContext, useEffect } from "react";
import { Box, Divider } from "@mui/material";
import SocialProof from "../SocialProof.js";
import { AuthContext } from "src/utils/AuthContext.js";
import Navbar from "../../blocks/Navbar.js";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import Footer from "../../blocks/Footer.js";
import { customEvent } from "src/utils/gtag.js";
import { redirectSignedOutUser } from "src/utils/Utils.js";
import NativeCheckout from "../../blocks/checkouts/NativeCheckout.js";
import ConsumerUpgradeContent from "./ConsumerUpgradeContent.js";

function ConsumerUpgrade() {
  const user = useContext(AuthContext).user;
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const trialPeriodDays = 7;
  const calendar = location.state?.calendar;

  // Get URLs from search params if present
  const successUrl = searchParams.get("successUrl")
    ? decodeURIComponent(searchParams.get("successUrl"))
    : undefined;

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "auto",
    });
  }, []);

  useEffect(() => {
    const source = location.state?.source || "direct_url_access";

    if (user) {
      customEvent({
        name: `landed_on_pay_now`,
        category: "Upgrade",
        label: `Landed on Pay Now`,
        data: {
          user_id: user._id,
          user_email: user.email,
          source: source,
        },
      });

      customEvent({
        name: `landed_on_pay_now_${source}`,
        category: "Upgrade",
        label: `Landed on Pay Now from ${source}`,
        data: {
          user_id: user._id,
          user_email: user.email,
          source: source,
        },
      });
    } else {
      customEvent({
        name: `landed_on_pay_now_${source}_signed_out`,
        category: "Upgrade",
        label: `Landed on Pay Now from ${source} (Signed Out)`,
        data: {
          source: source,
        },
      });
    }
  }, [user, location]);

  // Method to handle button click - scroll to top for logged in users, navigate for logged out users
  const handleUpgradeClick = () => {
    if (user) {
      // If user is logged in, scroll to top
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      // If user is not logged in, navigate to the upgrade page
      // Use the redirectSignedOutUser utility to handle the redirection
      redirectSignedOutUser(user, navigate);
      return;
    }
  };


  return (
    <div
      style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
    >
      <Navbar user={user} />
      <Box
        id="container"
        sx={{
          margin: "auto",
          maxWidth: { xs: "100%", sm: "800px" },
          position: "relative",
          p: 2,
          textAlign: "center",
        }}
      >
        {/* {calendar && <SocialProof calendar={calendar} />} */}
        {user && (
          <>
            <NativeCheckout
              type="consumer_annual"
              trialPeriodDays={trialPeriodDays}
              successUrl={successUrl}
              cancelUrl={location.pathname}
            />
            <Divider sx={{ my: 2.5 }} />
          </>
        )}
        <ConsumerUpgradeContent handleUpgradeClick={handleUpgradeClick} />
      </Box>
      <Footer />
    </div>
  );
}

export default ConsumerUpgrade;
